import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { AppBuilderAPI, ProjectsAPI } from '@makyoapp/makyo-sdk'
import { IProjectPresenter } from '@makyoapp/makyo-sdk/models/Projects'

import { queryKeys } from '@/lib/react-query'
import { useParamId } from '@/hooks/useParamId'

/**
 * Get project detail (in the app builder)
 */
export const useGetProjectDetail = (
  props: Omit<
    UseQueryOptions<IProjectPresenter, Error, IProjectPresenter, (string | undefined)[]>,
    'queryKey' | 'queryFn' | 'enabled'
  > = {}
) => {
  const projectId = useParamId('project')

  return useQuery({
    queryKey: [queryKeys.projectDetail, projectId],
    queryFn: () => {
      if (!projectId) throw new Error('Project ID is required')
      return ProjectsAPI.ReqGet(projectId)
    },
    enabled: !!projectId,
    ...props,
  })
}

/**
 * Get project version info history
 *
 * @todo: pagination from server
 */
export const useGetProjectVersionInfo = (appID: string) => {
  return useQuery({
    queryKey: [queryKeys.appVersionHistory, appID],
    queryFn: async () => {
      if (!appID) throw new Error('App ID is required')
      return await AppBuilderAPI.ReqGetVersionInfo(appID)
    },
    enabled: !!appID,
  })
}
